module.exports = __webpack_public_path__ + "img/reference35.4f00dd94.jpg";